<!--
<doc lang="markdown">
</doc>

<style scoped lang="scss">
</style>

<template lang="pug">
</template>
-->


<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import StageStamp from '../desktop/stage-stamp.vue'

  export default StageStamp
</script>
